import type { ReactNode } from 'react'

import { useAuth } from '../auth/AuthProvider.tsx'
import { AccountSection } from './AccountSection.tsx'

function scopeLabel(scope: string, ref: string | null): string {
  if (scope === 'NASIONAL') return 'Nasional'
  return `${scope === 'REGIONAL' ? 'Region' : 'TUK'} ${ref ?? '?'}`
}

/**
 * Profil pengguna: peran yang dipegang dan penggantian kata sandi.
 *
 * Terpisah dari beranda dengan sengaja. Beranda adalah halaman yang paling
 * sering dibuka dan ditinggalkan terbuka di layar; formulir kata sandi di sana
 * berarti kolom kata sandi menganggur pada perangkat bersama, dan tindakan yang
 * menutup seluruh sesi di semua perangkat berada satu salah-klik dari beranda.
 */
export function ProfilPage(): ReactNode {
  const { user } = useAuth()
  if (user === null || user === undefined) return null

  return (
    <div>
      <h1>Profil</h1>
      <p className="hint">
        {user.fullName} · <code>{user.username}</code>
      </p>

      <h2>Peran Anda pada sistem ini</h2>
      {user.roles.length === 0 ? (
        <p className="dt-empty">Belum ada peran. Hubungi panitia pusat.</p>
      ) : (
        <ul className="ringkas-list">
          {user.roles.map((grant, i) => (
            <li key={i}>
              <span>
                <code>{grant.role}</code>
              </span>
              <span>{scopeLabel(grant.scope, grant.scopeRef)}</span>
            </li>
          ))}
        </ul>
      )}

      <AccountSection />
    </div>
  )
}
